module.exports = __webpack_public_path__ + "img/charity_telegram.b37d6df3.png";